import React from 'react'
import { MutationFunc, graphql } from 'react-apollo'
import GoogleLogin, { GoogleAuthenticateSuccess } from '#src/components/GoogleLogin'
import FacebookLogin, { FacebookLoginResponse } from '#src/components/FacebookLogin'
import AuthenticateByExternalOAuthTokenDocument from './authenticateByExternalOAuthToken.gql'
import {
  OAuthType,
  AuthenticationResult,
  AuthenticateByExternalOAuthTokenMutation
} from '#src/generated/graphql'
import styles from './styles.css'

interface OAuthLoginProps {
  showFacebook: boolean
  showGoogle: boolean
  onAuthSuccess: () => void
  onAuthFailure: () => void
  onAuthChallenge?: () => void
}

interface Mutations {
  authenticateByExternalOAuthToken?: MutationFunc<AuthenticateByExternalOAuthTokenMutation>
}

class OAuthLogin extends React.Component<OAuthLoginProps & Mutations> {
  public constructor(props: OAuthLoginProps & Mutations) {
    super(props)

    this.handleOAuthResponse = this.handleOAuthResponse.bind(this)
    this.handleFacebookSuccess = this.handleFacebookSuccess.bind(this)
    this.handleGoogleSuccess = this.handleGoogleSuccess.bind(this)
  }

  private handleOAuthResponse({
    authenticateByExternalOAuthToken: response
  }: AuthenticateByExternalOAuthTokenMutation) {
    switch (response.result) {
      case AuthenticationResult.SUCCESS: {
        this.props.onAuthSuccess()
        break
      }

      case AuthenticationResult.FAILURE: {
        this.props.onAuthFailure()
        break
      }

      case AuthenticationResult.CHALLENGE: {
        this.props.onAuthChallenge ? this.props.onAuthChallenge() : () => null
        break
      }
    }
  }

  private handleGoogleSuccess(response: GoogleAuthenticateSuccess) {
    this.props.authenticateByExternalOAuthToken!({
      variables: {
        input: {
          type: OAuthType.GOOGLE,
          token: response.idToken
        }
      }
    }).then(request => {
      if (request) {
        this.handleOAuthResponse(request.data!)
      }
    })
  }

  private handleFacebookSuccess(userInfo: FacebookLoginResponse) {
    this.props.authenticateByExternalOAuthToken!({
      variables: {
        input: {
          type: OAuthType.FACEBOOK,
          token: userInfo.accessToken
        }
      }
    }).then(request => {
      if (request) {
        this.handleOAuthResponse(request.data!)
      }
    })
  }

  public render() {
    return (
      <>
        {this.props.showGoogle && (
          <GoogleLogin
            className={styles.loginButton}
            text="Continue with Google"
            onSuccess={this.handleGoogleSuccess}
          />
        )}
        {this.props.showFacebook && (
          <FacebookLogin
            className={styles.loginButton}
            text="Continue with Facebook"
            scope="public_profile,email"
            fields="first_name,last_name,email"
            onSuccess={this.handleFacebookSuccess}
          />
        )}
      </>
    )
  }
}

export default graphql<OAuthLoginProps & Mutations>(AuthenticateByExternalOAuthTokenDocument, {
  name: 'authenticateByExternalOAuthToken'
})(OAuthLogin)
